import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import LoginCompanyForm from './LoginCompanyForm';
import LoginWorksiteForm from './LoginWorksiteForm';
import { IsEmployeeMode, IsSupervisorMode } from '@users';

const useStyles = makeStyles((theme) => ({
    label: {
        textAlign: 'center'
    },
    divDialogHeader: {
        width: '360px',
        '@media (max-width: 600px)': {
            width: "350px"
        }
    },
    divDialogBody: {
        height: '200px',
        textAlign: 'center'
    },
    appBar: {
        position: 'relative',
    },
    titleAppBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
        fontSize: '1rem'
    },
    link: {
        marginTop: theme.spacing(2)
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function LoginStep2(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);

    const { openLoginStep2, handleClose, list, onChange } = props; // TODO : in onChange - Must add chat management when switching company (reset parameters + connect / disconnect chat) !!

    useEffect(() => {
        setOpen(openLoginStep2);
    }, [openLoginStep2]);

    const handleCloseClick = () => {
        handleClose();
    };

    return (
        <div className={classes.label}>
            <Dialog open={open} onClose={handleCloseClick} TransitionComponent={Transition}>
                <div data-id="headerLoginCompany" className={classes.divDialogHeader}>
                    <AppBar id="appBarTitle" className={classes.appBar}>
                        <Toolbar>
                            {/*<IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">*/}
                            {/*    <CloseIcon />*/}
                            {/*</IconButton>*/}
                            <Typography variant="h6" className={classes.titleAppBar}>
                                {IsEmployeeMode() && i18next.t('login:login.company.titleCompany')}
                                {IsSupervisorMode() && i18next.t('login:login.worksite.titleWorksite')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="divRootLoginCompany" className={classes.divDialogBody}>
                    {IsEmployeeMode() && <LoginCompanyForm companiesList={list} onChange={onChange} /> }
                    {IsSupervisorMode() && <LoginWorksiteForm worksitesList={list} onChange={onChange} /> }
                </div>
            </Dialog>
        </div>
    );
}

export default withNamespaces(['login'], { wait: true })(LoginStep2);